export const SPECIAL_CHARACTER_ID = 'misc';
export const SPECIAL_CHARACTER_LABEL = '#';
export const NAVIGATION_ITEMS_ARRAY = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'g',
  'h',
  'i',
  'j',
  'k',
  'l',
  'm',
  'n',
  'o',
  'p',
  'q',
  'r',
  's',
  't',
  'u',
  'v',
  'w',
  'x',
  'y',
  'z',
  SPECIAL_CHARACTER_ID,
];

export const DATA_TEST_IDS = {
  letterNavigationButton: 'letter_navigation_button',
  userBagsContainer: 'user_bags_container',
  filtersForm: {
    button: 'filters_form_button',
    input: 'filters_form_input',
  },
};
